{
  "checkedInTitle": "체크인되었습니다",
  "postCheckInInstructions": "체크인 후 안내",
  "appointmentDetails": "예약 세부 정보",
  "notifyWarehouse": "창고에서 수용 가능 여부를 확인할 수 있도록 도착 사실을 알렸습니다",
  "waitForStaff": "창고 직원의 추가 안내를 기다려 주세요",
  "unplannedDescription": "예약이 없는 것 같습니다. 창고 직원의 추가 안내를 기다려 주세요.",
  "whatsappDelay": "첫 번째 WhatsApp 메시지가 도착하는 데 최대 1분이 걸릴 수 있습니다.",
  "bookNextTitle": "다음 방문 예약하기",
  "bookNextBody": "Opendock에 가입하면 다음에 이 시설을 방문할 때 예약할 수 있습니다",
  "helpFooter": "도움이나 추가 정보가 필요하면 창고 직원에게 문의하세요",
  "finalize": "완료({seconds})"
}
